import { render, staticRenderFns } from "./CreateEditPromotionPage.vue?vue&type=template&id=2f2384b1&"
import script from "./CreateEditPromotionPage.vue?vue&type=script&lang=js&"
export * from "./CreateEditPromotionPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditPromotionPage.vue?vue&type=style&index=0&id=2f2384b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports